var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as __au2ViewDef from './table-app.html';
import { customElement } from '@aurelia/runtime-html';
let TableApp = class TableApp {
    constructor() {
        this.objectArray = [];
        this.objectArray2 = [];
        this.numberOfItems = 1000;
        this.isSelected = false;
        this.isVisible = true;
        this.selectedMarkup = 'div';
        this.$newArrayLength = 0;
    }
    setViewStrategy(strategy) {
        this.viewStrategy = strategy;
    }
    toggle() {
        this.isVisible = !this.isVisible;
    }
    click() {
        console.log('click');
    }
    setIsSelected() {
        this.isSelected = true;
    }
    createItem(index) {
        let name = faker.name.findName();
        return {
            firstLetter: name.charAt(0),
            name: name,
            color: faker.internet.color(),
            phone: faker.phone.phoneNumber(),
            country: faker.address.country()
        };
    }
    created() {
        let name;
        for (let i = 0; i < this.numberOfItems; ++i) {
            name = faker.name.findName();
            this.objectArray.push(this.createItem(i));
        }
        for (let i = 0; i < this.numberOfItems; ++i) {
            name = faker.name.findName();
            this.objectArray2.push(this.createItem());
        }
    }
    get contacts() {
        return this.objectArray;
    }
    swap() {
        this.objectArray = this.objectArray2;
    }
    addItems(count) {
        console.log(`adding ${count} items...`);
        const newItems = [];
        for (let i = 0; i < count; ++i) {
            newItems[i] = this.createItem(i);
        }
        this.objectArray.push(...newItems);
        console.log(`finsihed adding ${count} items`);
        this.numberOfItems = this.objectArray.length;
    }
    addItem2() {
        let item = this.createItem();
        this.objectArray.splice(1, 0, item);
    }
    addItemFirst(count = 10) {
        for (let i = 0; i < count; ++i) {
            this.objectArray.unshift(this.createItem());
        }
    }
    removeItems(count) {
        this.objectArray.splice(0, count);
    }
    unshift5() {
        this.objectArray.unshift(this.createItem(), this.createItem(), this.createItem(), this.createItem(), this.createItem());
    }
    addItemLast(count = 10) {
        while (count-- > 0) {
            this.objectArray.push(this.createItem());
        }
    }
    removeLast() {
        this.objectArray.pop();
    }
    newRandomArray(count = 1000) {
        this.objectArray = Array.from({ length: count }, () => this.createItem());
    }
};
TableApp = __decorate([
    customElement(__au2ViewDef)
], TableApp);
export { TableApp };
